import React, { useEffect, useState } from 'react';
import axios from 'axios';
import config from '../../config';

const PreMessagePage = () => {
  const [preMessages, setPreMessages] = useState([]);
  const [newMessage, setNewMessage] = useState('');
  const { API_URL } = config;

  useEffect(() => {
    fetchPreMessages();
  }, []);

  const fetchPreMessages = async () => {
    try {
      const response = await axios.get(`${API_URL}/api/premessage/`);
      setPreMessages(response.data);
    } catch (error) {
      console.error('Error fetching pre-messages:', error);
    }
  };

  const addPreMessage = async () => {
    try {
      const response = await axios.post(`${API_URL}/api/premessage/`, { text: newMessage });
      setPreMessages([...preMessages, response.data]);
      setNewMessage('');
    } catch (error) {
      console.error('Error adding pre-message:', error);
    }
  };

  const updatePreMessage = async (id, newText) => {
    try {
      const response = await axios.put(`${API_URL}/api/premessage/${id}`, { text: newText });
      setPreMessages(preMessages.map(msg => (msg._id === id ? response.data : msg)));
    } catch (error) {
      console.error('Error updating pre-message:', error);
    }
  };

  const deletePreMessage = async (id) => {
    try {
      await axios.delete(`${API_URL}/api/premessage/${id}`);
      setPreMessages(preMessages.filter(msg => msg._id !== id));
    } catch (error) {
      console.error('Error deleting pre-message:', error);
    }
  };

  return (
    <div className="p-6 max-w-3xl mx-auto">
      <h2 className="text-center text-2xl font-semibold mb-4">Pre-Written Messages</h2>
      <div className="flex mb-4">
        <input 
          type="text" 
          value={newMessage} 
          onChange={(e) => setNewMessage(e.target.value)} 
          placeholder="Enter new message" 
          className="border p-2 flex-grow rounded-md"
        />
        <button onClick={addPreMessage} className="bg-blue-500 text-white px-4 py-2 rounded-md ml-2">Add</button>
      </div>
      <ul className="space-y-2">
        {preMessages.map(msg => (
          <li key={msg._id} className="flex items-center justify-between bg-white p-3 shadow-md rounded-md">
            <input 
              type="text" 
              defaultValue={msg.text} 
              onBlur={(e) => updatePreMessage(msg._id, e.target.value)} 
              className="border p-2 rounded-md flex-grow"
            />
            <button onClick={() => deletePreMessage(msg._id)} className="bg-red-500 text-white px-3 py-1 rounded-md ml-2">Delete</button>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default PreMessagePage;
